export const computerMenuText = "e6b";
export const cloudLocationsMenuText = "f6b";
export const uploadAndShareFromCloudMenuText = "g6b";
export const uploadAndShareFromCloudMenuTooltip = "h6b";
export default {computerMenuText,cloudLocationsMenuText,uploadAndShareFromCloudMenuText,uploadAndShareFromCloudMenuTooltip};